import { proCheck } from '~teacher/util/proCheck';

import { QuizItemCache } from '../../../../api/quiz/getQuizzes/normalize/toQuizItemCache';
import { QuizOrFolder } from '../../../../api/quiz/getQuizzes/types';

export const getDeletedQuizFilter = () => (items: QuizItemCache) =>
  Object.values(items.itemById)
    .filter((item: QuizOrFolder) =>
      proCheck.canMakeFolders() ? true : item.type !== 'folder'
    )
    .filter((item: QuizOrFolder) => item.deleted);
